(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1) Animação do botão de adicionar ao carrinho (comportamento antigo)
     ------------------------------------------------------------------ */
  function initCartAnimation() {
    document.querySelectorAll('.product-form__submit').forEach(function (btn) {
      if (btn.dataset.vvAnim) return;
      btn.dataset.vvAnim = '1';

      var labelSpan = btn.querySelector('.btn-label, span:not(.svg-wrapper)');
      if (labelSpan && !labelSpan.classList.contains('vv-btn-label')) {
        labelSpan.classList.add('vv-btn-label');
      } else if (!btn.querySelector('.vv-btn-label')) {
        var nodes = Array.prototype.slice.call(btn.childNodes).filter(function (n) {
          return n.nodeType === Node.TEXT_NODE && n.textContent.trim();
        });
        nodes.forEach(function (n) {
          var s = document.createElement('span');
          s.className = 'vv-btn-label';
          s.textContent = n.textContent;
          btn.replaceChild(s, n);
        });
      }

      btn.addEventListener('click', function () {
        if (btn.classList.contains('vv-added')) return;
        btn.classList.add('vv-added');
        setTimeout(function () {
          btn.classList.remove('vv-added');
        }, 1200);
      });
    });
  }

  /* ------------------------------------------------------------------
     2) Selo de frete grátis, por variante

     O bloco é custom_liquid (templates/product.json), então o Dawn NÃO
     o re-renderiza na troca de variante — só troca o preço, o botão e o
     <script data-selected-variant>. O evento `variant:change` NÃO
     dispara neste tema (testado 05/08/2026). Por isso a sincronização é
     por MutationObserver lendo o JSON da variante selecionada.

     `data-selected-variant` foi COMPROVADO confiável para available/
     price/id (comparado contra a Admin API em 05/08). NÃO usar o estado
     do botão "Adicionar ao carrinho" como fonte — já foi tentado e o
     próprio botão é o que fica quebrado quando o `quantity_selector`
     sai do Liquid (ver vistavie-product.css).
     ------------------------------------------------------------------ */

  var PISO_PADRAO = 39900;

  function brl(cents) {
    return 'R$ ' + (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function setText(el, value) {
    if (!el) return;
    if (el.textContent.trim() === value) return; /* evita loop no observer */
    el.textContent = value;
  }

  function readSelectedVariant(scope) {
    var s = scope.querySelector('script[data-selected-variant]');
    if (!s || !s.textContent.trim()) return null;
    try {
      return JSON.parse(s.textContent);
    } catch (e) {
      return null;
    }
  }

  /* estoque real de cada variante, embutido pelo Liquid no carregamento
     da página (o data-selected-variant do Dawn não traz inventory_quantity) */
  function readVariantsData(scope) {
    var s = scope.querySelector('script[data-vv-variants]');
    if (!s || !s.textContent.trim()) return null;
    try {
      return JSON.parse(s.textContent);
    } catch (e) {
      return null;
    }
  }

  function findVariantMeta(scope, variantId) {
    var list = readVariantsData(scope);
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === variantId) return list[i];
    }
    return null;
  }

  function updateShipBadge(scope, variant) {
    var wrap = scope.querySelector('[data-vv-badges]');
    var item = scope.querySelector('[data-vv-ship]');
    var text = scope.querySelector('[data-vv-ship-text]');
    if (!wrap || !item || !text || typeof variant.price !== 'number') return;

    var piso = parseInt(wrap.getAttribute('data-vv-piso'), 10) || PISO_PADRAO;

    if (variant.price >= piso) {
      item.classList.remove('vv-trust-badges__item--gap');
      item.classList.add('vv-trust-badges__item--reached');
      setText(text, 'Frete grátis Sul/Sudeste');
    } else {
      item.classList.remove('vv-trust-badges__item--reached');
      item.classList.add('vv-trust-badges__item--gap');
      setText(text, 'Faltam ' + brl(piso - variant.price) + ' para frete grátis (Sul/Sudeste)');
    }
  }

  /* ------------------------------------------------------------------
     3) Promessa de envio / disponibilidade / estoque baixo

     Texto do estoque baixo é genérico ("Últimas unidades", sem número)
     a pedido da Giovana — evita mostrar contagem errada/desatualizada.
     ------------------------------------------------------------------ */

  function updateDispatch(scope, variant) {
    var el = scope.querySelector('[data-vv-dispatch]');
    if (!el) return;

    var status = el.querySelector('[data-vv-dispatch-status]');
    var ship = el.querySelector('[data-vv-dispatch-ship]');
    var sep = el.querySelector('[data-vv-dispatch-sep]');
    var indisponivel = variant.available === false;

    el.classList.toggle('vv-dispatch--out', indisponivel);
    if (sep) sep.hidden = indisponivel;
    if (ship) ship.hidden = indisponivel;

    if (indisponivel) {
      el.classList.remove('vv-dispatch--low');
      setText(status, 'Indisponível nesta combinação');
      return;
    }

    var meta = findVariantMeta(scope, variant.id);
    var low = !!(meta && meta.managed && typeof meta.qty === 'number' && meta.qty > 0 && meta.qty <= 3);

    el.classList.toggle('vv-dispatch--low', low);
    setText(status, low ? 'Últimas unidades' : 'Em estoque');
  }

  /* destaca no comparativo a linha do tamanho escolhido */
  function updateSizeTable(scope, variant) {
    var rows = scope.querySelectorAll('[data-vv-size-row]');
    if (!rows.length) return;
    var atual = (variant.option1 || '').trim();
    rows.forEach(function (row) {
      if (row.getAttribute('data-vv-size-row') === atual) {
        row.setAttribute('data-vv-size-current', '');
      } else {
        row.removeAttribute('data-vv-size-current');
      }
    });
  }

  /* ------------------------------------------------------------------
     4) Descrição recolhida com “ler mais”
     ------------------------------------------------------------------ */
  var LIMITE_DESC = 420;

  function initDescricao(scope) {
    var desc = scope.querySelector('.product__description');
    if (!desc || desc.dataset.vvDesc) return;
    if (desc.offsetHeight <= LIMITE_DESC) return;

    desc.dataset.vvDesc = '1';
    desc.classList.add('vv-desc-collapsed');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vv-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Ler descrição completa';
    desc.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      var aberto = desc.classList.toggle('vv-desc-collapsed') === false;
      btn.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      btn.textContent = aberto ? 'Mostrar menos' : 'Ler descrição completa';
      if (!aberto) desc.scrollIntoView({ block: 'nearest' });
    });
  }

  /* ------------------------------------------------------------------
     5) Descrição + Acordeões (FAQ/Garantia) embaixo da galeria no
        desktop (pedido 11/08 — evita o vão vazio abaixo da imagem
        quando a coluna de compra é mais curta que a galeria).

     No desktop (>=990px) os dois saem de dentro de #ProductInfo- (a
     coluna estreita de compra) e viram o último filho de
     .product__media-wrapper (a coluna de ~65% da galeria), formando
     uma 2ª "fileira" visual abaixo da imagem. Abaixo de 990px voltam
     pro lugar original (antes do comparativo de tamanhos), pra manter
     preço/botão de compra logo no topo no celular.

     `.product__accordion` pega só FAQ e Garantia — o bloco "Combine
     com" (complementary_products_vv) tem make_collapsible_row:false,
     então não usa essa classe e não é afetado.
     ------------------------------------------------------------------ */
  var vvDetailsWrap = null;

  function vvBuildDetailsWrap(scope) {
    if (vvDetailsWrap) return vvDetailsWrap;
    var desc = scope.querySelector('.product__description');
    var accordions = scope.querySelectorAll('.product__accordion');
    if (!desc && accordions.length === 0) return null;

    vvDetailsWrap = document.createElement('div');
    vvDetailsWrap.className = 'vv-details-left';
    if (desc) vvDetailsWrap.appendChild(desc);
    accordions.forEach(function (a) {
      vvDetailsWrap.appendChild(a);
    });
    return vvDetailsWrap;
  }

  function vvPlaceDetailsWrap(scope) {
    var wrap = vvBuildDetailsWrap(scope);
    if (!wrap) return;

    var mediaWrapper = document.querySelector('.product__media-wrapper');
    var isDesktop = window.matchMedia('(min-width: 990px)').matches;

    if (isDesktop && mediaWrapper) {
      if (wrap.parentElement !== mediaWrapper) mediaWrapper.appendChild(wrap);
    } else if (wrap.parentElement !== scope) {
      var sizesBlock = scope.querySelector('.vv-sizes');
      if (sizesBlock) {
        scope.insertBefore(wrap, sizesBlock);
      } else {
        scope.appendChild(wrap);
      }
    }

    initDescricao(wrap);
  }

  /* ------------------------------------------------------------------
     6) Widget de avaliações (Judge.me) na coluna da esquerda no
        desktop (pedido 12/08).

     Mesmo mecanismo do item 5, mas em elemento separado: o bloco de
     app do Judge.me é MOVIDO (não duplicado) pra dentro de
     .product__media-wrapper em >=990px e volta exatamente pro lugar
     original abaixo disso — guardamos o pai e o irmão seguinte pra
     recolocar na posição certa, não só no fim da lista.

     O bloco pode ser injetado depois do carregamento (script do app),
     por isso a função é chamada também de dentro do sync(), que roda
     a cada mutação observada em #ProductInfo-. É idempotente: se já
     está no lugar certo, não mexe (senão o próprio move viraria uma
     nova mutação em loop).
     ------------------------------------------------------------------ */
  var vvReviewsBlock = null;
  var vvReviewsHome = null;
  var vvReviewsAnchor = null;

  function vvPlaceReviews() {
    if (!vvReviewsBlock) {
      var widget = document.getElementById('judgeme_product_reviews');
      if (!widget) return;
      var block = widget.closest('.shopify-block') || widget;
      if (!block.parentElement) return;
      /* só faz sentido mover o que nasceu dentro da coluna de compra */
      if (!block.closest('[id^="ProductInfo-"]')) return;
      vvReviewsBlock = block;
      vvReviewsHome = block.parentElement;
      vvReviewsAnchor = block.nextElementSibling;
    }

    var mediaWrapper = document.querySelector('.product__media-wrapper');
    var isDesktop = window.matchMedia('(min-width: 990px)').matches;

    if (isDesktop && mediaWrapper) {
      /* precisa ficar como ÚLTIMO filho: a descrição + acordeões
         (vvPlaceDetailsWrap) também são anexados aqui, e as avaliações
         vêm depois deles. Sem o teste de lastElementChild a ordem
         dependia de quem rodasse primeiro. */
      if (vvReviewsBlock.parentElement !== mediaWrapper || mediaWrapper.lastElementChild !== vvReviewsBlock) {
        vvReviewsBlock.classList.add('vv-reviews-left');
        mediaWrapper.appendChild(vvReviewsBlock);
      }
    } else if (vvReviewsBlock.parentElement !== vvReviewsHome) {
      vvReviewsBlock.classList.remove('vv-reviews-left');
      if (vvReviewsAnchor && vvReviewsAnchor.parentElement === vvReviewsHome) {
        vvReviewsHome.insertBefore(vvReviewsBlock, vvReviewsAnchor);
      } else {
        vvReviewsHome.appendChild(vvReviewsBlock);
      }
    }
  }

  /* ------------------------------------------------------------------
     7) Comparativo de tamanhos: miniatura por tamanho + linha clicável
        (pedido 12/08).

     HOJE tamanho é VARIANTE do mesmo produto (P/M/G), então "ir pro
     tamanho" = selecionar aquela variante. O <a> renderizado pelo
     Liquid aponta pra ?variant=<id> (funciona sem JS e é um link de
     verdade); aqui o clique é interceptado pra marcar o rádio do
     tamanho — troca sem recarregar a página e PRESERVA a cor
     escolhida, que um link fixo não conseguiria.

     Quando os tamanhos virarem produtos separados (plano de migração
     de 11/08), basta o Liquid passar a apontar pro handle do outro
     produto: o fallback do link nativo assume sozinho, porque não vai
     existir rádio de tamanho pra interceptar.
     ------------------------------------------------------------------ */
  function readSizeVariants(scope) {
    var s = scope.querySelector('script[data-vv-size-variants]');
    if (!s || !s.textContent.trim()) return null;
    try {
      return JSON.parse(s.textContent);
    } catch (e) {
      return null;
    }
  }

  /* troca a foto/link de cada linha pra variante daquele tamanho NA COR
     atualmente selecionada (cai na 1ª variante do tamanho se a
     combinação não existir) */
  function updateSizeThumbs(scope, variant) {
    var rows = scope.querySelectorAll('[data-vv-size-row]');
    if (!rows.length) return;
    var data = readSizeVariants(scope);
    if (!data) return;

    var cor = null;
    for (var i = 0; i < data.length; i++) {
      if (data[i].id === variant.id) {
        cor = data[i].cor;
        break;
      }
    }

    rows.forEach(function (row) {
      var tam = row.getAttribute('data-vv-size-row');
      var alvo = null;
      var primeiro = null;
      for (var j = 0; j < data.length; j++) {
        if (data[j].tam !== tam) continue;
        if (!primeiro) primeiro = data[j];
        if (cor && data[j].cor === cor) {
          alvo = data[j];
          break;
        }
      }
      alvo = alvo || primeiro;
      if (!alvo) return;

      var img = row.querySelector('[data-vv-size-img]');
      if (img && alvo.img && img.getAttribute('src') !== alvo.img) {
        img.setAttribute('src', alvo.img);
      }
      var link = row.querySelector('[data-vv-size-link]');
      if (link && alvo.url) link.setAttribute('href', alvo.url);
      row.setAttribute('data-vv-size-variant', alvo.id);
    });
  }

  function initSizeLinks(scope) {
    var bloco = scope.querySelector('.vv-sizes');
    if (!bloco || bloco.dataset.vvSizeLinks) return;
    bloco.dataset.vvSizeLinks = '1';

    bloco.addEventListener('click', function (ev) {
      var row = ev.target.closest ? ev.target.closest('[data-vv-size-row]') : null;
      if (!row) return;

      var tam = row.getAttribute('data-vv-size-row');
      /* o comparativo só existe quando a 1ª opção é "Tamanho", então o
         1º fieldset do formulário é o seletor de tamanho */
      var fieldset = scope.querySelector('fieldset.product-form__input');
      if (!fieldset) return; /* sem seletor: deixa o link nativo agir */

      var alvo = null;
      fieldset.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (!alvo && r.value === tam) alvo = r;
      });

      if (!alvo) {
        var sel = fieldset.querySelector('select');
        if (!sel) return; /* sem seletor: deixa o link nativo agir */
        ev.preventDefault();
        if (sel.value === tam) return;
        sel.value = tam;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        vvSubirParaGaleria();
        return;
      }

      ev.preventDefault();
      if (alvo.checked) return;
      alvo.checked = true;
      alvo.dispatchEvent(new Event('change', { bubbles: true }));
      vvSubirParaGaleria();
    });
  }

  function vvSubirParaGaleria() {
    var alvo = document.querySelector('.product__media-wrapper') || document.querySelector('.product');
    if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ------------------------------------------------------------------ */

  function sync(scope) {
    var variant = readSelectedVariant(scope);
    if (variant) {
      updateShipBadge(scope, variant);
      updateDispatch(scope, variant);
      updateSizeTable(scope, variant);
      updateSizeThumbs(scope, variant);
    }
    initCartAnimation();
    initSizeLinks(scope);
    vvPlaceReviews();
  }

  function watch(scope) {
    if (scope.dataset && scope.dataset.vvWatched) return;
    if (scope.dataset) scope.dataset.vvWatched = '1';

    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        sync(scope);
      }, 60);
    });

    observer.observe(scope, { childList: true, subtree: true });
    /* descrição/acordeões ANTES das avaliações: as duas coisas vão pro
       mesmo container (.product__media-wrapper) e a ordem visual da
       coluna da esquerda é imagem → descrição → FAQ/Garantia → avaliações */
    vvPlaceDetailsWrap(scope);
    sync(scope);

    var mq = window.matchMedia('(min-width: 990px)');
    mq.addEventListener('change', function () {
      vvPlaceDetailsWrap(scope);
      vvPlaceReviews();
    });
  }

  function init() {
    initCartAnimation();
    document.querySelectorAll('[id^="ProductInfo-"]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('variant:change', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('[id^="ProductInfo-"]') : null;
    var scope = target || document.querySelector('[id^="ProductInfo-"]');
    if (!scope) return;
    sync(scope);
  });
})();
